import { scaleOrdinal } from '@visx/scale';
import { unionWith, values } from 'lodash';
import { IWidgetItem } from '../../../types/analytics';
import { PIE_CHART_RANGE } from './theme';

export const useLegendDomain = (itemsEnum: any, items: IWidgetItem[]) => {
	const domain = unionWith<string>(
		values(itemsEnum),
		items.map((l: IWidgetItem) => l.name),
		(a, b) => a.toLowerCase() === b.toLowerCase()
	);

	return {
		getColorFrequency: scaleOrdinal({
			domain,
			range: PIE_CHART_RANGE
		})
	};
};
